import { Component, inject, Input, ViewChild } from '@angular/core';
import { DateInputComponent } from 'components/input/date-input/date-input.component';
import { CredentialType } from 'enums/CredentialType';
import { ProductPlanModel } from 'models/generated/Entities.GormCrm.ProductPlan';
import { Layout } from 'modules/layout';
import { TranslatePipe } from 'pipes/translate.pipe';
import { AccountingService } from 'services/accounting.service';
import { CredentialRequired } from 'services/credential.service';
import { DateService } from 'services/date.service';
import { FormValidationService } from 'services/form-validation.service';
import { NavigationService } from 'services/navigation.service';

@CredentialRequired(CredentialType.EditAccountingPlan)
@Component({
	templateUrl: './undo-terminate-product-plan.component.html',
	providers: [FormValidationService],
	imports: [Layout, DateInputComponent, TranslatePipe]
})
export class UndoTerminateProductPlanComponent {

	private readonly accountingService = inject(AccountingService);
	private readonly dateService = inject(DateService);
	private readonly navigation = inject(NavigationService);
	
	@ViewChild('terminationDateInput') terminationDateInput?: DateInputComponent;
	@Input() accountingPlanId?: string;
	@Input()
	set productPlan(plan: ProductPlanModel | undefined) {
		if (!plan?.restrictEndDate) return;

		this.subscriptionEndDatesFilter = [this.dateService.nextBirthday(this.dateService.addDays(plan.autoRenewalDate, -1), plan.restrictEndDate)];
		this.minDate = this.subscriptionEndDatesFilter[0]; // Min date makes the input suggest a valid date without filling in the this.newEndDate ahead of time (which would force the input to always be pristine)
	}
	
	subscriptionEndDatesFilter?: Date[];
	newEndDate?: Date;
	minDate?: Date;
		
	undoTerminate() {
		if (!this.newEndDate || !this.accountingPlanId) return;
		this.accountingService.undoTerminateAccountingPlan(this.accountingPlanId, this.newEndDate).then(() => { this.navigation.closeView(this); });
	}

	changedEndDate(endDate: Date) {
		this.newEndDate = endDate
	}

	markAsPristine() { }
}
